import { SelectionListItem } from "../../../../Forms/SelectionListItem";

export interface SelectedTtProtectionFilters {
  SpdrClassifications: Array<SelectionListItem<string>>;
  PlantGsdbs: Array<SelectionListItem<string>>;
  PlantTypes: Array<SelectionListItem<string>>;
  IeoPlantGsdbs: Array<SelectionListItem<string>>;
  SupplierCountryIds: Array<SelectionListItem<number>>;
  SupplierRegions: Array<SelectionListItem<string>>;
  SupplierZipAreas: Array<SelectionListItem<string>>;
  SupplierGsdbs: Array<SelectionListItem<string>>;
  OdcGsdbs: Array<SelectionListItem<string>>;
  CrossingCountryIds: Array<SelectionListItem<number>>;
  FtlRouteNumbers: Array<SelectionListItem<string>>;
}

export const emptyTtProtectionFilterSelection: SelectedTtProtectionFilters = {
  SpdrClassifications: [],
  PlantGsdbs: [],
  PlantTypes: [],
  IeoPlantGsdbs: [],
  SupplierCountryIds: [],
  SupplierRegions: [],
  SupplierZipAreas: [],
  SupplierGsdbs: [],
  OdcGsdbs: [],
  CrossingCountryIds: [],
  FtlRouteNumbers: [],
};
